module.exports = __webpack_public_path__ + "img/pen-line.78030809.svg";